export const QUESTION_REQUEST = 'QUESTION_REQUEST';
export const QUESTION_SUCCESS = 'QUESTION_SUCCESS';
export const QUESTION_FAIL = 'QUESTION_FAIL';